export const BookingState = {
  ACTIVE: 'Active',
  CANCELED: 'Canceled',
  DELETED: 'Deleted',
  PENDING: 'Pending',
  SEATED: 'Seated',
  NO_SHOW: 'Noshow'
};

export const BookingType = {
  RESERVATION: 'Reservation',
  WALKIN: 'Walkin',
  WAITPARTY: 'Waitparty'
};
